import { useCallback } from 'react';
import { useAiSearchErrorToast } from '~/hooks/useAiSearchErrorToast';
import { useLocaleKeys } from '~/i18n';
import { useDraftsAiSearchStore } from './useDraftsAiSearchStore';
const errorMessage = (t, errorCode)=>{
    switch(errorCode){
        case 'feature_disabled':
            return t.featureDisabled();
        case 'llm_timeout':
            return t.llmTimeout();
        case 'llm_error':
            return t.llmError();
        case 'llm_invalid_response':
            return t.llmInvalidResponse();
        case 'llm_schema_validation_failed':
            return t.llmSchemaValidationFailed();
        case 'search_failed':
            return t.searchFailed();
        case 'cannot_extract':
            return t.cannotExtract();
        case 'unknown':
            return t.unknown();
        default:
            return t.generic();
    }
};
export const useDraftsAiSearchErrorToast = (toastTestId)=>{
    const { t } = useLocaleKeys('proposal.draftsDashboard.aiSearch.errors');
    const errorCode = useDraftsAiSearchStore((s)=>s.errorCode);
    const setError = useDraftsAiSearchStore((s)=>s.setError);
    useAiSearchErrorToast({
        hasError: errorCode != null,
        clearError: useCallback(()=>setError(null), [
            setError
        ]),
        message: errorCode == null ? '' : errorMessage(t, errorCode),
        toastTestId
    });
};
